/**
 * This is part of the new Rider Funnel experience
 */
SC.resetPassword = (function () {
  var api = {};

  var init = function () {
    initializeResetPassword();
  };

  var initializeResetPassword = function () {
    var $resetPasswordForm = $('form.form-reset-password-submit');
    var $resetPasswordButton = $('#handle-reset-password');
    var $formError = $('.global-form__error');

    $resetPasswordForm.on('submit', function (e) {
      e.preventDefault();
      resetPasswordSubmit();
    });

    $resetPasswordButton.on('click', function () {
      resetPasswordSubmit();
    });

    /**
     * resetPasswordSubmit send the request to reset the password
     * @returns {void}
     */
    var resetPasswordSubmit = function () {
      $resetPasswordForm.clearFormErrors();
      $resetPasswordForm.updateCsrfToken();
      $formError.text('');

      $resetPasswordForm.ajaxSubmit({
        dataType: 'json',

        success: function (data) {
          $resetPasswordButton.prop('disabled', false);
          $resetPasswordForm.updateCsrfToken();
          if (data.success) {
            $resetPasswordButton.prop('disabled', true);
            confirmation(null, 'Password reset was successful. Redirecting to the login page now.');
            if (data.redirect_url) {
              window.location = data.redirect_url;
            } else {
              window.location = '/';
            }
            return;
          }

          $resetPasswordForm.fieldErrors(data.fieldErrors);

          if (!data.fieldErrors) {
            $formError.text(data.message || genericErrorMessage);
          }
        },

        error: function () {
          $resetPasswordForm.updateCsrfToken();
          $formError.text(genericErrorMessage);
          $resetPasswordButton.prop('disabled', false);
        }
      });
    };

    $resetPasswordForm.on('submit', function (e) {
      e.preventDefault();
      resetPasswordSubmit();
    });

    $resetPasswordButton.on('click', function () {
      $resetPasswordButton.prop('disabled', true);
    });
  };

  init();

  return api;
})();
